import { Stack, Typography } from "@mui/material";
import MessagesSection from "../components/Messages/MessagesSection";

function Messages() {
  return (
    <Stack
      id="network-container"
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "22px",
        p: "20px",
      }}
    >
      <MessagesSection />
    </Stack>
  );
}

export default Messages;
